(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('multiSelect', multiSelect);

    /* @ngInject */
    function multiSelect() {
        var directive = {
            bindToController: true,
            templateUrl: 'multi-select.tpl',
            controller: multiSelectCtrl,
            controllerAs: '$ctrl',
            link: link,
            restrict: 'E',
            require: '?ngModel',
            scope: {
                choices: '=options',
                key: '@',
                title: '@text'
            }
        };
        return directive;

        function link(scope, element, attrs, ngModel) {
            // console.log(['multiSelect.link', scope, element, attrs, ngModel]);
            if(!ngModel) { return; } // do nothing if no ng-model

            scope.$ctrl.choose = choose;
            scope.$ctrl.clear = clear;
            scope.$ctrl.chooseAll = chooseAll;
            scope.$ctrl.clearAll = clearAll;

            function resort() {
                scope.$ctrl.available.sort(function(a, b) { return a[scope.$ctrl.key] - b[scope.$ctrl.key]; });
                scope.$ctrl.chosen.sort(function(a, b) { return a[scope.$ctrl.key] - b[scope.$ctrl.key]; });
                setViewValue();
            }

            scope.$watch(function() { return ngModel.$modelValue; }, function(newValue, oldValue, scope) {
                console.log(['multiSelect.link.watch.$modelValue', ngModel.$modelValue]);
            });

            scope.$watch('$ctrl.choices', function(newValue, oldValue, scope) {
                // console.log(['multiSelect.link.watch.choices', scope.$ctrl.choices]);
                angular.forEach(scope.$ctrl.choices, function(choice, cidx) {
                    var inAvailable = scope.$ctrl.available.map(function(obj) { return obj[scope.$ctrl.key]; }).indexOf(choice[scope.$ctrl.key]),
                        inChosen = scope.$ctrl.chosen.map(function(obj) { return obj[scope.$ctrl.key]; }).indexOf(choice[scope.$ctrl.key]);
                    if(inAvailable < 0 && inChosen < 0) { scope.$ctrl.available.push(choice); }
                    if(inAvailable >= 0) { scope.$ctrl.available[inAvailable][scope.$ctrl.title] = choice[scope.$ctrl.title]; }
                    if(inChosen >= 0) { scope.$ctrl.chosen[inChosen][scope.$ctrl.title] = choice[scope.$ctrl.title]; }
                    // console.log([cidx, choice, inAvailable, inChosen]);
                });
                // console.log('availableToRemove');
                var availableToRemove = [];
                angular.forEach(scope.$ctrl.available, function(choice, cidx) {
                    var inChoices = scope.$ctrl.choices.map(function(obj) { return obj[scope.$ctrl.key]; }).indexOf(choice[scope.$ctrl.key]);
                    if(inChoices < 0) { availableToRemove.push(cidx); }
                    // console.log([cidx, inChoices, choice.title]);
                });
                // console.log(availableToRemove);
                for(var i = availableToRemove.length - 1; i >= 0; i--) {
                    scope.$ctrl.available.splice(availableToRemove[i], 1); scope.$ctrl.selA[availableToRemove[i]] = false;
                }
                // console.log('chosenToRemove');
                var chosenToRemove = [];
                angular.forEach(scope.$ctrl.chosen, function(choice, cidx) {
                    var inChoices = scope.$ctrl.choices.map(function(obj) { return obj[scope.$ctrl.key]; }).indexOf(choice[scope.$ctrl.key]);
                    if(inChoices < 0) { chosenToRemove.push(cidx); }
                    // console.log([cidx, inChoices, choice.title]);
                });
                // console.log(chosenToRemove);
                for(var j = chosenToRemove.length - 1; j >= 0; j--) {
                    scope.$ctrl.chosen.splice(chosenToRemove[j], 1); scope.$ctrl.selC[chosenToRemove[j]] = false;
                }
                resort();
            }, true);

            // function inChoise(obj) {
            //     var rs = false;
            //     angular.forEach(scope.$ctrl.choices, function(choice, cidx) { if(angular.equals(obj, choice)) { rs = true; } });
            //     return rs;
            // }

            function choose() {
                var toRemove = []; angular.forEach(scope.$ctrl.selA, function(item, idx) {
                    if(item) { scope.$ctrl.chosen.push(scope.$ctrl.available[idx]); toRemove.push(idx); }
                });
                for(var i = toRemove.length - 1; i >= 0; i--) { scope.$ctrl.available.splice(toRemove[i], 1); }
                scope.$ctrl.selA = []; resort();
            }

            function clear() {
                var toRemove = []; angular.forEach(scope.$ctrl.selC, function(item, idx) {
                    if(item) { scope.$ctrl.available.push(scope.$ctrl.chosen[idx]); toRemove.push(idx); }
                });
                for(var i = toRemove.length - 1; i >= 0; i--) { scope.$ctrl.chosen.splice(toRemove[i], 1); }
                scope.$ctrl.selC = []; resort();
            }

            function chooseAll() {
                angular.forEach(scope.$ctrl.available, function(item, idx) {
                    scope.$ctrl.chosen.push(scope.$ctrl.available[idx]);
                });
                scope.$ctrl.available = []; scope.$ctrl.selA = []; resort();
            }

            function clearAll() {
                angular.forEach(scope.$ctrl.chosen, function(item, idx) {
                    scope.$ctrl.available.push(scope.$ctrl.chosen[idx]);
                });
                scope.$ctrl.chosen = []; scope.$ctrl.selC = []; resort();
            }

            function setViewValue() {
                ngModel.$setViewValue(scope.$ctrl.chosen);
            }

            setViewValue();

        }

    }

    /* @ngInject */
    function multiSelectCtrl($scope) {
        $scope.$ctrl.available = [];
        $scope.$ctrl.chosen = [];
        $scope.$ctrl.selA = [];
        $scope.$ctrl.selC = [];
    }

})();